import { Progress, Space } from 'antd';
import { useEffect } from 'react';
const ProgressBar = (props) => {
    const {progress,setProgress} = props
    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prevProgress) => prevProgress + 10);
        }, 300);
        return () => clearInterval(timer);
    }, []);
    return (
        <Space wrap>
            <Progress type="dashboard" trailColor='rgba(92, 179, 62, 0.49)' strokeColor={'#57B33E'} percent={progress} gapDegree={0} setProgress={setProgress} />
        </Space>
    )
}
export default ProgressBar;